export const LOGIDS = [33036, 31002, 31009, 31127, 31128, 31129, 31130, 31131];

export const AWS_CONNECT_URL = 'core-lib/assets/aws-sdk-firehose/aws-sdk-firehose.js';

export const APP_LOADED_SUBCRIBER = 'awsconnect_bmaloaded';

export const messageMap = {
    31002: 'sessionTokenLogin success',
    31009: 'sessionTokenLogin error',
    31128: 'startWindowSession success',
    31129: 'startWindowSession error',
    31131: 'endWindowSession success',
};

export const AWSCONSTANTS = {
    ENV_PROD_PROFILE: 'production',
    ENV_PROD: 'prod',
    ENV_NONPROD: 'nonprod',
    REGION: 'eu-west-2',
};

export const ACTIONS = {
    RJ_ABANDON: 'RJ: journey is abandoned',
    RJ_START_LOGIN: 'RJ: login started',
    RJ_LOGIN_SUCCEEDED: 'RJ: login succeeded',
    RJ_LOGIN_FAILED: 'RJ: login failed',
    RJ_START_SIGNUP: 'RJ: signup is started',
    RJ_SIGNUP_SUCCEEDED: 'RJ: signup succeeded',
    RJ_SIGNUP_FAILED: 'RJ: signup failed',
    RJ_UPGRADE_TO_MC_SUCCEEDED: 'RJ: upgrade from InShop to MC succeeded',
    RJ_UPGRADE_TO_MC_FAILED: 'RJ: upgrade from InShop to MC failed',
    RJ_REDIRECT_TO_GAMING: 'RJ: redirected to gaming',
    RJ_REDIRECT_TO_DEPOSIT_SUCCEEDED: 'RJ: redirected to deposit succeeded',
    RJ_REDIRECT_TO_DEPOSIT_FAILED: 'RJ: redirected to deposit failed',
    RJ_FIRST_DEPOSIT_FAILED: 'RJ: first deposit failed',
    RJ_FIRST_DEPOSIT_SUCCEEDED: 'RJ: first deposit succeeded',
    BPP_PLACEBET_SUCCESS: 'PlaceBetSuccess',
    BPP_PLACEBET_ERROR: 'PlaceBetError',
    BPP_BUILDBET_SUCCESS: 'BuildBetSuccess',
    BPP_BUILDBET_ERROR: 'BuildBetError',
    BPP_BUILDBETLOGGED_SUCCESS: 'BuildBetSuccess',
    BPP_BUILDBETLOGGED_ERROR: 'BuildBetError',
    BPP_BUILDCOMPLEXLEGS_SUCCESS: 'BuildBetSuccess',
    BPP_BUILDCOMPLEXLEGS_ERROR: 'BuildBetError',
    BPP_READBET_SUCCESS: 'ReadBetSuccess',
    BPP_READBET_ERROR: 'ReadBetError',
    FEATURED_WS_CONNECTION_SUCCESS: 'FEATURED_WS_CONNECTION_SUCCESS',
    INPLAY_WS_CONNECTION_SUCCESS: 'INPLAY_WS_CONNECTION_SUCCESS',
    FEATURED_WS_CONNECTION_FAILED: 'FEATURED_WS_CONNECTION_FAILED',
    INPLAY_WS_CONNECTION_FAILED: 'INPLAY_WS_CONNECTION_FAILED',
    FEATURED_WS_RECONNECTION_SUCCESS: 'FEATURED_WS_RECONNECTION_SUCCESS',
    INPLAY_WS_RECONNECTION_SUCCESS: 'INPLAY_WS_RECONNECTION_SUCCESS',
    FEATURED_WS_RECONNECTION_FAILED: 'FEATURED_WS_RECONNECTION_FAILED',
    INPLAY_WS_RECONNECTION_FAILED: 'INPLAY_WS_RECONNECTION_FAILED',
    FEATURED_WS_STRUCTURE_RECEIVED: 'FEATURED_WS_STRUCTURE_RECEIVED',
    INPLAY_WS_STRUCTURE_RECEIVED: 'INPLAY_WS_STRUCTURE_RECEIVED',
    FEATURED_WS_RECONNECTION_ATTEMP: 'FEATURED_WS_RECONNECTION_ATTEMP',
    INPLAY_WS_RECONNECTION_ATTEMP: 'INPLAY_WS_RECONNECTION_ATTEMP',
    TIMELINE_WS_CONNECTION_SUCCESS: 'TIMELINE_WS_CONNECTION_SUCCESS',
    TIMELINE_WS_CONNECTION_FAILED: 'TIMELINE_WS_CONNECTION_FAILED',
    TIMELINE_WS_RECONNECTION_SUCCESS: 'TIMELINE_WS_RECONNECTION_SUCCESS',
    TIMELINE_WS_RECONNECTION_FAILED: 'TIMELINE_WS_RECONNECTION_FAILED',
    TIMELINE_WS_RECONNECTION_ATTEMP: 'TIMELINE_WS_RECONNECTION_ATTEMP',
    INSIGHTS_WS_CONNECTION_SUCCESS: 'INSIGHTS_WS_CONNECTION_SUCCESS',
    INSIGHTS_WS_CONNECTION_FAILED: 'INSIGHTS_WS_CONNECTION_FAILED',
    INSIGHTS_WS_RECONNECTION_SUCCESS: 'INSIGHTS_WS_RECONNECTION_SUCCESS',
    INSIGHTS_WS_RECONNECTION_FAILED: 'INSIGHTS_WS_RECONNECTION_FAILED',
    INSIGHTS_WS_RECONNECTION_ATTEMP: 'INSIGHTS_WS_RECONNECTION_ATTEMP',
    INSIGHTS_WS_STRUCTURE_RECEIVED: 'INSIGHTS_WS_STRUCTURE_RECEIVED',
    NOT_FOUND_PAGE_HIT: 'NOT_FOUND_PAGE_HIT',
};
